
exports.showPdfProgress = (pdfsource) => {
  return {
    type: 'SHOW_PDFPROGRESS',
    payload: pdfsource
  }
}

exports.setPdfSrc = (pdfsource) => {
  return {
    type: 'PDF_SRC',
    payload: pdfsource
  }
}

exports.hidePdfProgress = () => {
  return {
    type: 'HIDE_PDFPROGRESS'
  }
}

exports.chapterToPdf = (chapter) => {
  return {
    type: 'CHAPTER_TO_PDF',
    payload: chapter
  }
}

exports.allChaptersToPdf = (isSelected) => {
  return {
    type: 'ALL_CHAPTERS_TO_PDF',
    payload: isSelected
  }
}






  



// WEBPACK FOOTER //
// ./src/modules/download/downloadActions.js